export enum TsePartnerIdentificationType {
    PASSPORT = 'passport',
    OFFICIAL_ID_DOCUMENT = 'officialIdDocument',
    RESIDENCE_CERTIFICATE = 'residenceCertificate',
    OTHER = 'other',
}


